import ISO_3166_1_ALPHA_2_CODES from "../isoCodes/iso3166Alpha2Codes";
import ISO_4217_CODES from "../isoCodes/iso4217Codes";
import ISO_639_CODES from "../isoCodes/iso629Codes";
/**
 * This function checks if the value complies foramt based on ISO format for language (ISO 639-1) and country code
 * (ISO 3166-1 alpha-2). The language and country should be separated using an underscore ( _ ).
 *
 * @param locale Only string is accepted.
 * @returns true/false
 */
export var isLocaleValid = function (locale) {
    if (!isString(locale)) {
        return false;
    }
    var regex = new RegExp("^[a-z]{2}_[A-Z]{2}$");
    if (!regex.test(locale)) {
        return false;
    }
    var localeSplit = locale.split("_");
    var language = localeSplit[0];
    var countryCode = localeSplit[1];
    if (!isIso639(language)) {
        return false;
    }
    if (!isIso3166Alpha2(countryCode)) {
        return false;
    }
    return true;
};
/**
 * This funciton checks if the value is a string.
 *
 * @param value Any value is accepted.
 * @returns true/false
 */
export var isString = function (value) {
    var type = typeof value;
    return (type === "string" ||
        (type === "object" &&
            value !== null &&
            !Array.isArray(value) &&
            Object.prototype.toString.call(value) === "[object String]"));
};
var CONSUMER_NAME_FORMAT = new RegExp("^(?:\\p{L}\\p{M}*)+(?:[ '\\u2019\\u02BC\\u2010\\u2011-](?:\\p{L}\\p{M}*)+)*$", "u");
/**
 * Checks whether a Consumer name contains only Unicode letters, combining marks and supported name separators.
 * Supported separators are spaces, apostrophes and hyphens, and each separator must occur between letter groups.
 */
export var isConsumerNameFormatValid = function (value) {
    return typeof value === "string" && CONSUMER_NAME_FORMAT.test(value.trim());
};
/**
 * This function checks if the value complies with ISO 3166-1 alpha-2 standard.
 *
 * @param value Only string is accepted.
 * @returns true/false
 */
export var isIso3166Alpha2 = function (value) {
    return ISO_3166_1_ALPHA_2_CODES.includes(value);
};
/**
 * This function checks if the value complies with ISO 4217 standard.
 *
 * @param value Only string is accepted.
 * @returns true/false
 */
export var isIso4217 = function (value) {
    return ISO_4217_CODES.includes(value);
};
/**
 * This function checks if the value complies with ISO 639-1 standard.
 *
 * @param value Only string is accepted.
 * @returns true/false
 */
export var isIso639 = function (value) {
    return ISO_639_CODES.includes(value);
};
/**
 * This functions checks if the string value is numeric.
 *
 * @param value Only string is accepted.
 * @returns true/false
 */
export var isNumeric = function (value) {
    if (typeof value != "string") {
        return false;
    }
    return !isNaN(Number(value)) && !isNaN(parseFloat(value));
};
